export const NOTIFICATION_DEFAULT_WIDTH = '33.500rem'
